import Axios from 'axios';
import credentialsService from 'services/credentialsService';
import env from 'env';

const authHttpClient = Axios.create({
  baseURL: `${env.SERVER_ENDPOINT}/`,
});

authHttpClient.interceptors.request.use(
  function (config) {
    const { registrationToken } = credentialsService;
    if (registrationToken && config.method !== 'OPTIONS') {
      config.headers.Authorization = `Bearer ${registrationToken}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

authHttpClient.interceptors.response.use(null, (error) => {
  if (error.response && [401, 403].includes(error.response.status)) {
    console.error(error.response?.data?.message);
    credentialsService.removeAuthBody();
    window.location.pathname = '';
  }
  return Promise.reject(error);
});

export default authHttpClient;
